/* eslint-disable react-refresh/only-export-components */
import { StrictMode, Suspense, useEffect, useLayoutEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { BrowserRouter, Route, Routes, useLocation } from "react-router";
import Layout from '@/components/Layout.tsx'
import { PostHogProvider } from 'posthog-js/react'
import React from 'react'
import NProgress from 'nprogress';
import "nprogress/nprogress.css";

const ActorProfile = React.lazy(() => import('./components/ActorProfile.tsx'));
const TermsOfService = React.lazy(() => import('./components/TermsOfService.tsx'));
const RefundPolicy = React.lazy(() => import('./components/RefundPolicy.tsx'));
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy.tsx'));
const About = React.lazy(() => import('./pages/About.tsx'));
const HashtagAnalytics = React.lazy(() => import('./pages/HashtagAnalytics.tsx'));
const UserBookmarkedPosts = React.lazy(() => import('./pages/UserBookmarkedPosts.tsx'));

const options = {
  api_host: import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST,
}

const queryClient = new QueryClient()

const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
}

const LazyLoad = () => {
  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  });

  return '';
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PostHogProvider
        apiKey={import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY}
        options={options}
      >
        <BrowserRouter>
          <ScrollToTop>
            <Suspense fallback={<LazyLoad />}>
              <Routes>
                <Route element={<Layout />} >
                  <Route index element={<App />} />
                  <Route path="terms-of-service" element={<TermsOfService />} />
                  <Route path="refund-policy" element={<RefundPolicy />} />
                  <Route path="privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="about" element={<About />} />
                  <Route path="realtime/hashtags" element={<HashtagAnalytics />} />
                  <Route path='bookmarks' element={<UserBookmarkedPosts />} />
                  <Route path=':actor' element={<ActorProfile />} />
                </Route>
              </Routes>
            </Suspense>
          </ScrollToTop>
        </BrowserRouter>
      </PostHogProvider>
    </QueryClientProvider>
  </StrictMode>,
)
